import type { AppState } from '../types';

const KEY = (slug: string) => `lunchbook:v1:${slug}`;

export function saveLocal(slug: string, state: AppState): void {
  try {
    localStorage.setItem(KEY(slug), JSON.stringify(state));
  } catch {
    // quota or disabled storage — non-fatal
  }
}

export function loadLocal(slug: string): AppState | null {
  try {
    const raw = localStorage.getItem(KEY(slug));
    if (!raw) return null;
    return JSON.parse(raw) as AppState;
  } catch {
    return null;
  }
}

export function clearLocal(slug: string): void {
  try { localStorage.removeItem(KEY(slug)); } catch {}
}
